(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.ManageAllEntities",
                {
                    url: "/ManageAllEntities",
                    component: "manageAllEntities",
                    requiredPermissions: [{ AccessObject: 'TransactionGroupAll', ActionType: 'View' }],
                    resolve: {
                        transactionGroups: [
                            "transactionGroupApi", function (transactionGroupApi) {
                                return transactionGroupApi.getTransactionGroups();
                            }
                        ]
                    }
                });
        }
    ]);

    var templatePath = 'App/Dashboard/ConfigureTransactionGroupEntity/template.html';

    app.component("manageAllEntities",
        {
            templateUrl: templatePath,
            controller: manageAllEntitiesController,
            bindings: {
                transactionGroups: "<"
            }
        });

    manageAllEntitiesController.$inject = ["$state", "$mdDialog", "$scope", "transactionGroupApi"];

    function manageAllEntitiesController($state, $mdDialog, $scope, transactionGroupApi) {
        var $ctrl = this;
        this.$state = $state;
        this.$scope = $scope;

        ng.extend($ctrl,
            {
                allEntities: [],
                createEntityModal: createEntityModal,
                closeModal: closeModal,
                editProduct: editProduct,
                addNewEntity: addNewEntity,
                UI: {}
            });

        this.$onInit = function () {
            $ctrl.manageAllEntities = "Manage All Entities";
            $ctrl.backToConfig = "Back to configuration";
            $ctrl.entityTxt = "Entity";
            $ctrl.sysStatus = "System Status";
        };

        function addNewEntity(ne) {
            $ctrl.UI.IsSaving = true;
            transactionGroupApi.createNewTransactionGroup({ Name: $ctrl.NewTransactionGroupName }).then(function () {
                transactionGroupApi.getTransactionGroups().then(function (d) {
                    $ctrl.UI.IsSaving = false;
                    $ctrl.NewTransactionGroupName = null;
                    $ctrl.transactionGroups = d;
                    $ctrl.closeModal();
                });
            });
        }

        function editProduct(product) {
            return $state.go("Home.ManageAllEntities.TransactionGroup", { transactionGroupId: product.Id });
        }

        function showAlertDialog() {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Sorry')
                    .textContent('That entity does not exist in our records.')
                    .ariaLabel('Alert Dialog for nonexisting entitiy')
                    .ok('OK')
                    .targetEvent()
            );
        }

        function createEntityModal($event) {
            var ourDialog = {
                contentElement: '#myDialog',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            };

            //var createEntity = $mdDialog.show(ourDialog);

            $mdDialog.show(ourDialog).then(function () { goToDashboard(); });
        }

        function closeModal() { $mdDialog.hide(); }
    }

})(window.app, window.angular);